const AVAX_ADDRESS_REGEX = /^(0x[0-9A-Fa-f]{40}|[XP]-avax[0-9A-za-z]{39})$/

export default {
    isValidAddress: function (address) {
        return AVAX_ADDRESS_REGEX.test(address)
    },
}
